import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './styles/main.sass'
import HomePage from './pages/HomePage'
import { ROUTES } from './resources/other-constants'
import RecapPage from './pages/RecapPage'
import PrivacyPage from './pages/PrivacyPage'
import AppointmentDetailPage from './pages/AppointmentDetailPage'

const MainLayout:React.FC = () => {
    
    return (
        <BrowserRouter basename={!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? process.env.PUBLIC_URL : '/ccpisa-landing'}>
            <div className="page-container">
                {/** <Header /> */}
                <Routes>
                    <Route path={ROUTES.HOMEPAGE_ROUTE} element={<HomePage />} />
                    <Route path={ROUTES.RECAPPAGE_ROUTE} element={<RecapPage />} />
                    <Route path={ROUTES.PRIVACY_ROUTE} element={<PrivacyPage />} />
                    <Route path={`${ROUTES.APPOINTMENT_DETAIL}`} element={<AppointmentDetailPage />} />
                </Routes>
            </div>
        </BrowserRouter>
    )
}

export default MainLayout
